import { c as _c } from "react/compiler-runtime";
import { RemoveFromProjectDialog } from "@components/project/remove-from-project-dialog";
import { useCompanyId } from "@context-providers/company-id-provider";
import { Alert } from "@flat-ui";
import { useProjectMemberActions } from "@hooks/projects/use-project-member-actions";
import { Stack } from "@mui-wrapper";
import { ProjectMember } from "@pages/projects/project-member";
import { useState } from "react";
/** Renders the members of a project in the share dialog */
export function ProjectMemberList(t0) {
  const $ = _c(21);
  const {
    project,
    members,
    location
  } = t0;
  const companyId = useCompanyId();
  const memberActions = useProjectMemberActions(project);
  const [memberToRemove, setMemberToRemove] = useState(null);
  if (members.length === 0) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Alert variant="info" title="This project has no invited members" />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      maxHeight: "300px",
      overflow: "auto",
      gap: 2
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== location || $[3] !== memberActions || $[4] !== members || $[5] !== project) {
    let t3;
    if ($[7] !== location || $[8] !== memberActions || $[9] !== project) {
      t3 = member => <ProjectMember key={member.identity} member={member} shouldHideRemove={!memberActions.canRemove(member)} isRoleEditable={memberActions.canChangeRole(member)} onRemove={setMemberToRemove} projectId={project.id} location={location} />;
      $[7] = location;
      $[8] = memberActions;
      $[9] = project;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    t2 = members.map(t3);
    $[2] = location;
    $[3] = memberActions;
    $[4] = members;
    $[5] = project;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[11] !== t2) {
    t3 = <Stack sx={t1}>{t2}</Stack>;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== companyId || $[14] !== location || $[15] !== memberToRemove || $[16] !== project) {
    t4 = memberToRemove && <RemoveFromProjectDialog companyId={companyId} project={project} member={memberToRemove} location={location} onClose={() => setMemberToRemove(null)} />;
    $[13] = companyId;
    $[14] = location;
    $[15] = memberToRemove;
    $[16] = project;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== t3 || $[19] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
}